import { FC } from 'react';

import { BannerModerationState, getBannerTextTypography } from 'utils/banner/utils';

import { Flex, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BannerSourceLabel } from 'components/Banners/components/Banner/components/BannerModeration/components/BannerSourceLabel';

interface BannedBySourceListProps {
    states: BannerModerationState[];
}

const TrlKeys = {
    banned: 'BannersPage.banner.status.banned',
};

export const BannedBySourceList: FC<BannedBySourceListProps> = ({ states }) => {
    const { isMobile } = useBreakpoint();
    const trls = useTrls();

    const typography = getBannerTextTypography(isMobile);

    return (
        <Flex gap={12} direction="column">
            {states.map(({ source, moderationReason }) => (
                <Flex key={source} gap={4} direction="column">
                    <Flex gap={isMobile ? 4 : 8} direction={isMobile ? 'column' : 'row'}>
                        <Text typography={typography} style="negative">
                            {trls(TrlKeys.banned)}
                        </Text>
                        <BannerSourceLabel source={source} />
                    </Flex>
                    <Text typography={typography}>{moderationReason}</Text>
                </Flex>
            ))}
        </Flex>
    );
};
